import type { SVGProps } from 'react';
export const Filters = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="M16.89 4.27a1.3 1.3 0 0 0-1.19-.77H4.3A1.3 1.3 0 0 0 3.02 5q.06.4.32.67v.01l4.33 4.63v4.89a1.3 1.3 0 0 0 1.36 1.3q.36-.02.65-.22l2.08-1.39a1.3 1.3 0 0 0 .57-1.08v-3.5l4.32-4.63h.01a1.3 1.3 0 0 0 .23-1.4m-5.9 5.2a.8.8 0 0 0-.21.53v3.67l-1.56 1.04V10q0-.31-.2-.53L4.88 5.06h10.22z" />
  </svg>
);
